import qs from "qs";
import { i18nRegistry } from "./i18nRegistry";
export const ORDER_INPROGRESS = 'In-progress';
export const ORDER_CANCELED = 'Canceled';
export const ORDER_OPEN = 'Open';

export const INVOICE_STATUS_OPEN = 'INVOICE_STATUS_OPEN';
export const INVOICE_STATUS_PAID = 'INVOICE_STATUS_PAID';
export const INVOICE_STATUS_SENT = 'INVOICE_STATUS_SENT';
export const INVOICE_STATUS_CANCELLED = 'INVOICE_STATUS_CANCELLED';
export const INVOICE_STATUS_OVERRIDE = 'INVOICE_STATUS_OVERRIDE';


export const languageCode = [
  { label: "en_US" },
]
export const whatsappProviders = [
  { label: "Route Mobile",
   },
]

export const telecallingProviders = [
{ label: "Twilio",
   },
]
export const telecallingStatusData = [
    { 
        label: "TELECALLING_STATUS_ACTIVE",
   },
   { 
        label: "TELECALLING_STATUS_INACTIVE",
   },
]

export const indianStates = [
  { label: "Other" },
  { label: "Andhra Pradesh" },
  { label: "Arunachal Pradesh" },
  { label: "Assam" },
  { label: "Bihar" },
  { label: "Chhattisgarh" },
  { label: "Goa" },
  { label: "Gujarat" },
  { label: "Haryana" },
  { label: "Himachal Pradesh" },
  { label: "Jharkhand" },
  { label: "Karnataka" },
  { label: "Kerala" },
  { label: "Madhya Pradesh" },
  { label: "Maharashtra" },
  { label: "Manipur" },
  { label: "Meghalaya" },
  { label: "Mizoram" },
  { label: "Nagaland" },
  { label: "Odisha" },
  { label: "Punjab" },
  { label: "Rajasthan" },
  { label: "Sikkim" },
  { label: "Tamil Nadu" },
  { label: "Telangana" },
  { label: "Tripura" },
  { label: "Uttar Pradesh" },
  { label: "Uttarakhand" },
  { label: "West Bengal" },
  { label: "Andaman and Nicobar Islands" },
  { label: "Chandigarh" },
  { label: "Dadra and Nagar Haveli and Daman and Diu" },
  { label: "Delhi" },
  { label: "Jammu and Kashmir" },
  { label: "Ladakh" },
  { label: "Lakshadweep" },
  { label: "Puducherry" }
];
  
  

  export const lead_customer_income = [
    {
        label: "Low",
    },
    {
        label: "Medium",
    },
    {
        label: "High",
    }
]


export const invoice_status = [
    {
        label: "created",
    },
    {
        label: "pdf-generated",
    },
    {
        label: "paid",
    }
]

export const salesOrderStatus = {
    SO_STATUS_OPEN:"SO_STATUS_OPEN",
    SO_STATUS_PARTIALLY_INVOICED:"SO_STATUS_PARTIALLY_INVOICED",
    SO_STATUS_COMPLETELY_INVOICED:"SO_STATUS_COMPLETELY_INVOICED",
    SO_STATUS_CANCELLED:"SO_STATUS_CANCELLED",
    SALES_ORDER_STATUS_OVERRIDE:"SALES_ORDER_STATUS_OVERRIDE"
}

export const permissionList = {
    DASHBOARD_VIEW: "lms_dashboard_view",
    MERCHANT_VIEW: "lms_vendor_view",
    PRODUCT_VIEW: "lms_product_view",
    LEAD_VIEW: "lms_lead_view",
    ORDER_VIEW: "lms_salesorder_view",
    INVOICE_VIEW: "lms_invoice_view",
     TASK_VIEW: "lms_task_view",
    DASHBOARD_MANAGE: "lms_dashboard_manage",
    MERCHANT_MANAGE: "lms_vendor_manage",
    PRODUCT_MANAGE: "lms_product_manage",
    ALL_LEAD_MANAGE: "lms_all_lead_manage",
    LEAD_MANAGE: "lms_lead_manage",
    ORDER_MANAGE: "lms_salesorder_manage",
    ALL_ORDER_MANAGE : "lms_all_sales_order_manage",
    ALL_INVOICE_MANAGE : "lms_all_invoice_manage",
    ALL_TASK_MANAGE: "lms_all_task_manage",
    INVOICE_MANAGE: "lms_invoice_manage",
    CUSTOMER_MANAGE: "lms_customer_manage",
    CUSTOMER_VIEW: "lms_customer_view",
    CONFIGURATION_MANAGE: "lms_configuration_manage",
    CONFIGURATION_VIEW: "lms_configuration_view",
    NOTIFICATION_MANAGE: "lms_notification_manage",
    NOTIFICATION_VIEW: "lms_notification_view",
    TEMPLATE_VIEW: "lms_template_view",
    TEMPLATE_MANAGE: "lms_template_manage",
    AUDIT_VIEW: "lms_auditlogs_manage",
    AUDIT_MANAGE: "lms_auditlogs_manage",
    LEAD_TEAM_MANAGE : "lms_myteam_lead_manage",
    ORDER_TEAM_MANAGE :"lms_myteam_sales_order_manage",
    INVOICE_TEAM_MANAGE : "lms_myteam_invoice_manage",
    REPORT_VIEW : "lms_report_view",
    REPORT_MANAGE : "lms_report_manage",
    TASK_MANAGE : "lms_task_manage",
    TASK_TEAM_MANAGE : "lms_myteam_task_manage",
    WORKFLOW_VIEW : "lms_workflow_view",
    WORKFLOW_MANAGE : "lms_workflow_manage",
    AIML_MANAGE : "lms_aiml_access"
}

export const teampermissionList = ["lms_all_lead_manage","lms_all_sales_order_manage","lms_all_invoice_manage", "lms_myteam_lead_manage", "lms_myteam_sales_order_manage", "lms_myteam_invoice_manage","lms_all_task_manage", "lms_myteam_task_manage"]

export const myTeampermission = ["lms_myteam_lead_manage", "lms_myteam_sales_order_manage", "lms_myteam_invoice_manage","lms_myteam_task_manage"];

export const defaultmenuLabel = {
    "lead": "Lead",
    "customer": "Customer",
    "order": "Order",
    "invoice": "Invoice",
    "product": "Product",
    "merchant": "Merchant",
    "dashboard": "Dashboard",
    "campaign": "Notification",
    "template": "Template",
    "companyDetails": {
        name: "A1 Business",
        code: "ABC"
    }

}

export const OrganizationmenuLabel = {
    "lead": "Lead Test",
    "customer": "Customer Test",
    "order": "Order Test",
    "invoice": "Invoice Test",
    "product": "Product Test",
    "merchant": "Merchant Test",
    "dashboard": "Dashboard Test",
    "template": "Template",
    "campaign": "Notification",
    "companyDetails": {
        name: "A1 Test Business",
        code: "ABCTEST"
    }
}

export const notificationGroupTemplate = [
    {
        name: "Lead",
        value: "lead"
    },
    {
        name: "Customer",
        value: "customer"
    },
    {
        name: "Owner",
        value: "owner"
    },
    
]

export const dyanmicConstantAttribute = [
    {
        label: "Customer Name",
        value: "lms_customer_name"
    },
    {
        label: "Product Name",
        value: "lms_product_name"
    },
    {
        label: "Product Size",
        value: "lms_product_Size"
    },
    {
        label: "Product Price",
        value: "lms_product_price"
    },
    
]


export const LEAD_STATUS = "LEAD_STATUS";
export const LEAD_STATUS_PROSPECT = "LEAD_STATUS_PROSPECT";
export const LEAD_ATTRIBUTE = "LEAD_ATTRIBUTE";
export const LEAD_SOURCE = "LEAD_SOURCE";
export const LEAD_DESIRABILITY = "LEAD_DESIRABILITY";
export const LEAD_INCOME = "LEAD_INCOME";
export const CUSTOMER_STATUS = "CUSTOMER_STATUS";
export const CUSTOMER_SOURCE = "CUSTOMER_SOURCE";
export const CUSTOMER_DOC_TYPE = "CUSTOMER_DOC_TYPE";
export const VENDOR_STATUS = "VENDOR_STATUS";
export const VENDOR_DOC_TYPE = "VENDOR_DOC_TYPE";
export const CLIENT_DOC_TYPE = "CLIENT_DOC_TYPE";
export const COMMON_DOC_STATUS = "COMMON_DOC_STATUS";
export const CLIENT_DT_LOGO = "CLIENT_DT_LOGO";
export const LEAD_STATUS_DEAL_CLOSED = "LEAD_STATUS_DEAL_CLOSED";
export const PRODUCT_TYPE = "PRODUCT_TYPE";
export const PRODUCT_UOM = "PRODUCT_UOM";
export const PRODUCT_DOC_TYPE = "PRODUCT_DOC_TYPE";
export const SALES_ORDER_STATUS = "SALES_ORDER_STATUS";
export const INVOICE_STATUS = "INVOICE_STATUS";
export const PRODUCT_STATUS = "PRODUCT_STATUS";
export const ACTIVE_STATUS = "ACTIVE";
export const TEMPLATE_CHANNEL = "TEMPLATE_CHANNEL";
export const TEMPLATE_STATUS = "TEMPLATE_STATUS";
export const TEMPLATE_TYPE = "TEMPLATE_TYPE";
export const TASK_STATUS = "TASK_STATUS"
export const TASK_PRIMARY_TYPE = "TASK_PRIMARY_TYPE"
export const TASK_SECONDARY_TYPE = "TASK_SECONDARY_TYPE"
export const TASK_SOURCE = "TASK_SOURCE"
export const TASK_STATUS_CLOSED = 'TASK_STATUS_CLOSED';
export const TASK_STATUS_CANCELLED = 'TASK_STATUS_CANCELLED';
export const TASK_EXCLUDED_SYSTEM_CODES = [TASK_STATUS_CLOSED, TASK_STATUS_CANCELLED];

export const I18N_TASK_SUBTASKS        = 'TASK_SUBTASKS';
export const I18N_TASK_CREATE_SUBTASK  = 'TASK_CREATE_SUBTASK';
export const I18N_TASK_PARENT_TASK     = 'TASK_PARENT_TASK';
export const I18N_TASK_CLOSE_TITLE   = 'TASK_CLOSE_CONFIRM_TITLE';
export const I18N_TASK_CLOSE_DESC    = 'TASK_CLOSE_CONFIRM_DESC';

export const  TASK_PRIORITY = [
    {label:"TASK_PRIORITY_HIGH"},
    {label: "TASK_PRIORITY_MEDIUM"},
    {label:"TASK_PRIORITY_LOW"}
    ]

export const allowedLogoTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
export const allowedOtherTypes = [
  "application/pdf",
  "application/msword", // .doc
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
  "application/vnd.ms-excel", // .xls
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
  "text/csv", // .csv
  "image/jpeg",
  "image/jpg",
  "image/png"
];

export const lookuprecorddata = [
    {
        lookuptypename: "LEAD_STATUS",
        systemlookupcode: "Open, Closed, inprogress",
        id: 1
    },
    {
        lookuptypename: "LEAD_ATTRIBUTE",
        systemlookupcode: "cold, warm, hot",
        id: 2
    },
    {
        lookuptypename: "LEAD_INCOME",
        systemlookupcode: "High, Low",
        id: 3
    },
   

]


export const leadStaticData = {
    "LEAD_PHONE_NUMBER": "Phone Number",
    "LEAD_EMAIL": "Email",
    "LEAD_OWNER": "Owner",
    "LEAD_SALE_COMMISION": "Sale Commision(%)",
    "LEAD_FOLLOWUP_NOTE": "Note",
    "LEAD_NEXT_FOLLOWUP_DATE": "Next follow up",
    "LEAD_INTERESTED_PRODUCT": "Interested in products",
    "LEAD_ALREDAY_A_CUSTOMER": "Already a customer",
    "LEAD_FOLLOWUP": "Lead followup",
    "LEAD_DOCUMENT": "Lead document",
    "LEAD_CREATE_COPY_LEAD": "Create copy lead",
    "LEAD_CANCEL":"cancel this lead",
    "LEAD_REASSIGN": "Lead Re-assign",
    "LEAD_SELECTED_CANCEL": "cancel Selected Lead",
    "LEAD_CREATE_LEAD": "Create lead",
    "LEAD_BULK_UPLOAD": "Bulk Upload",
    "LEAD_LEAD_SEARCH": "Lead Search",
    "LEAD_NAME": "Name",
    "LEAD_CREATED_FROM": "Created from",
    "LEAD_CREATED_TO": "Created to",
    "LEAD_UPDATED_FROM": "Updated from",
    "LEAD_CREATED_AT": "Created at",
    "LEAD_UPDATED_AT": "Updated at",
    "LEAD_ACTIONS": "Actions",
    "LEAD_BACK": "Back",
    "LEAD_SAVE": "Save",
    "LEAD_UPDATE": "Update",
    "LEAD_SELECT_TEMPLATE": "Select Template",
    "LEAD_SELECT_FILE": "Select File",
    "LEAD_UPLOAD": "Upload",
    "LEAD_CREATE_NEW_TEMPLATE": "Create new template",
    "LEAD_PROCESS_SELECTED_FILE": "Process selected file",
    "LEAD_PRODUCT_TYPE": "Type",
    "LEAD_PRODUCT_PRICE_FROM": "Price from",
    "LEAD_PRODUCT_PRICE_TO": "Price to",
    "LEAD_PRODUCT_PRODUCT": "Product",
    "LEAD_PRODUCT_ADD": "Add",
    "LEAD_UPDATED_TO": "Updated To",
    "LEAD_SOURCE":"Source",
    "LEAD_STATUS": "Status",
    "LEAD_RESET":"Reset",
    "LEAD_INCOME_GROUP": "Income Group",
    "LEAD_ATTRIBUTE": "Attribute value",
    "LEAD_CANCEL_CONFIRMATION": "Are you sure want to cancel this Lead ?",
    "LEAD_CANCEL_DIALOG_TITLE": "Cancel Lead",
    "LEAD_DEAL_CLOSED_DIALOG_TITLE": "Deal Closed Confirmation",
    "LEAD_DEAL_CLOSED_DIALOG_DESCRIPTION": "  Check the final products sold in this deal. To edit the product qty or price, please update it in the lead first and then close the deal",
    "LEAD_DEAL_CLOSE_BUTTON": "Close The Deal",
    "LEAD_FINAL_DEAL_CLOSE_DIALOG_TITLE": "Deal Closed Final Confirmation",
    "LEAD_FINAL_DEAL_CLOSE_DESCRIPTION": "  Are you sure to close the deal with this lead?",
    "LEAD_BULK_UPLOAD_FINISHED_TEXT": " Bulk Upload finished. Download the processed file to review the errors, if any then submit again.",
    "LEAD_BULK_UPLOAD_FILE_COLUMN":"File Columns",
    "LEAD_LEAD": "Lead",
    "LEAD_BULK_UPLOAD_DB_COLUMN":" DB Columns",
    "DASHBOARD_SIDEBAR_MENU": "Dashboard",
    "CUSTOMER_SIDEBAR_MENU": "Customer",
    "MERCHANT_SIDEBAR_MENU": "Merchant",
    "PRODUCT_SIDEBAR_MENU": "Product",
    "ORDER_SIDEBAR_MENU": "Order",
    "INVOICE_SIDEBAR_MENU": "Invoice",
    "NOTIFICATION_SIDEBAR_MENU": "Notification",
    "CONFIGURATION_SIDEBAR_MENU": "Configurations",
    "TEMPLATE_SIDEBAR_MENU": "Template",
    "LEAD_SIDEBAR_MENU": "Lead"
}

export const customerAgeGroup = [
    {name : "15 to 20"},
    { name : "21 to 30"},
    { name : "30 to 50"},  
]


export const handleValidateCodevalue = (storedata, code) => {
    const value = storedata?.hasOwnProperty(code) ? storedata?.[code] : code;

    // Track genuine i18n keys for the Inspector drawer
    if (code && storedata?.hasOwnProperty(code)) {
        i18nRegistry.register(value, code);
    }

    return value;
}

export const ACTIONABLES_CALENDAR_MAX_SPAN_TEXT_LENGTH = 28;
export const ACTIONABLES_CALENDAR_MAX_VISIBLE_SLOTS = 2;
export const ACTIONABLES_CALENDAR_PAST_MONTHS_LIMIT = 12;
export const ACTIONABLES_CALENDAR_FUTURE_MONTHS_LIMIT = 3;
export const ACTIONABLES_CALENDAR_BAR_HEIGHT = 26;
export const ACTIONABLES_CALENDAR_BAR_GAP = 4;
export const ACTIONABLES_CALENDAR_DAY_HEADER_HEIGHT = 28;
export const ACTIONABLES_CALENDAR_DEFAULT_STATUS_COLOR = '#79B1CC';
export const ACTIONABLES_CALENDAR_PILL_BG_OPACITY = 0.14;
export const ACTIONABLES_CALENDAR_PILL_HOVER_OPACITY = 0.24;
export const ACTIONABLES_CALENDAR_CARD_BG_OPACITY = 0.12;
export const ACTIONABLES_CALENDAR_CARD_HOVER_OPACITY = 0.22;
export const ACTIONABLES_CALENDAR_NOTE_MAX_LENGTH = 120;
export const ACTIONABLES_CALENDAR_WEEK_DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const ACTIONABLES_CALENDAR_ENTITY_CONFIG = {
    lead: {
        idField: 'leadId',
        createdDateField: 'leadCreatedAt',
        statusField: 'leadStatus',
        statusType: 'lead',
        displayName: 'Lead',
        defaultSubtitle: 'Lead',
        isLead: true
    },
    task: {
        idField: 'taskId',
        createdDateField: 'taskCreatedAt',
        statusField: 'taskStatus',
        statusType: 'task',
        displayName: 'Task',
        defaultSubtitle: 'Task',
        isLead: false
    }
};
export const ACTIONABLE_DETAIL_CARD_I18N_KEYS = {
    leadId: 'LEAD_SEARCH_LEAD_ID',
    taskId: 'TASK_SEARCH_TASK_ID',
    parentTaskId: 'TASK_SEARCH_PARENT_TASK_ID',
    leadName: 'LEAD_SEARCH_FULLNAME',
    customer: 'TASK_SEARCH_CUSTOMER_NAME',
    description: 'TASK_EDIT_DESCRIPTION',
    startDate: 'COMMON_CREATED_AT',
    followupDate: 'DB_COL_FU_DATE',
    leadNote: 'LEAD_SEARCH_FU_NOTE',
    taskNote: 'TASK_ACTIVITY_NOTE',
    dealValue: 'LEAD_SEARCH_TOTAL_VALUE'
};

export const auditEntity = [
    {
        name: "LEAD_SIDEBAR_MENU",
        id: "LEAD_SIDEBAR_MENU" 
    },
    {
        name: "CUSTOMER_SIDEBAR_MENU",
        id: "CUSTOMER_SIDEBAR_MENU" 
    },
    {
        name: "VENDOR_SIDEBAR_MENU",
        id: "VENDOR_SIDEBAR_MENU" 
    },
    {
        name: "PRODUCT_SIDEBAR_MENU",
        id: "PRODUCT_SIDEBAR_MENU" 
    },
    {
        name: "SALES_ORDER_SIDEBAR_MENU",
        id: "SALES_ORDER_SIDEBAR_MENU" 
    },
    {
        name: "INVOICE_SIDEBAR_MENU",
        id: "INVOICE_SIDEBAR_MENU" 
    },
    {
        name: "CONF_MENU_USER",
        id: "CONF_MENU_USER" 
    },
    {
        name: "CONF_MENU_CLIENT",
        id: "CONF_MENU_CLIENT" 
    },
    {
        name: "TEMPLATE_SIDEBAR_MENU",
        id: "TEMPLATE_SIDEBAR_MENU"
    },
    {
        name: "TASKS_SIDEBAR_MENU",
        id: "TASKS_SIDEBAR_MENU"
    }

]

export const entitylist = {
    "Customer": "Customer",
    "CustomerProduct" : "Customer",
    "CustomerDocument" : "Customer",
    "Lead": "Lead",
    "LeadProduct": "Lead",
    "LeadFollowup": "Lead",
    "LeadDocument" : "Lead",
    "Task": "Task",
    "TaskActivity": "Task",
    "TaskDocument" : "Task",
    "Product": "Product",
    "ProductDocument" : "Product",
    "Vendor": "Vendor",
    "VendorDocument" : "Vendor",
    "SalesOrderProduct": "SalesOrder",
    "SalesOrder": "SalesOrder",
    "UserRole": "User",
    "Invoice": "Invoice",
    "InvoiceProduct": "Invoice",
    "Template": "Template",
    "TemplateAttachment": "Template",
    "User": "User",
    "Client": "Client",

}

export const filterSelection = [
    {
        name: "Last 7 days",
        value: ""
    },
    {
        name: "Last 15 days",
        value: ""
    },
    {
        name: "Last 30 days",
        value: ""
    },
    {
        name: "Last 90 days",
        value: ""
    }
]

/** Default date range (in days) used as the initial filter in all dashboard charts. */
export const DEFAULT_CHART_DATE_RANGE_DAYS = 7;

export const colorCode = ['#4FC8F7','#B5FCCD', '#A1E3CD', '#8DCACC', '#79B1CC', '#1434C9', '#B950CB','#E17FF1', '#F07F92', '#FFCC9C'];

export const actionColumnWidth = 20;
export const phoneWidth = 150;
export const nameWidth = 135;
export const productNameWidth=200;
export const fullNameWidth = 180;
export const emailWidth = 250;
export const idWidth = 90;
export const parentTaskIdWidth=120;
export const followupWidth = 250;
export const statusWidth = 120;
export const statusChipWidth=90;
export const ownerWidth = 150;
export const whocolumnWidth = 120;
export const customerIdWidth = 100;
export const vendorIdWidth = 100;
export const productIdWidth = 100;
export const vendorNameWidth=180;
export const productTypeWidth = 180;
export const salesOrderIdWidth = 150;
export const sellingPriceWidth = 120;
export const templateSubjectWidth = 350;
export const templateSTFtWidth = 150; // STF = System Template Flag
export const constitutionOfBusinessWidth = 200;
export const priceAfterDiscount = 160;
export const systemLookupCodeWidth = 1000;
export const taskSecondaryTypeWidth = 160;
export const workflowTypesWidth = 500;
export const workflowNameWidth=250;
export const workflowTriggerTypeWidth = 260;
export const leadIdWidth = 90;
export const bulkUploadRecordsWidth = 140;

export const productRecommendationColumnWidths = {
    productName : 120,
    probability : 180,
    sourceProducts : 180,
    lastBoughtDate : 220
}


export const  reportTypeList = [
    {
        name:"LEAD_SUMMARY",
        value :"LEAD_SUMMARY",
    },
    {
        name:"LEAD_HISTORY",
        value : "LEAD_HISTORY"
    },
    {
        name : "CUSTOMER_SUMMARY",
        value : "CUSTOMER_SUMMARY"
    },
      {
        name:"TASK_SUMMARY",
        value :"TASK_SUMMARY",
    },
        {
        name : "TASK_HISTORY",
        value : "TASK_HISTORY"
    },
    ]

export const  commonTitles = [
    {name:"COMMON_TITLE_MR"},
    {name:"COMMON_TITLE_MRS"},
    {name: "COMMON_TITLE_MISS"},
    {name: "COMMON_TITLE_MS"}
    ]

export const commonLCType = [
    {name:"COMMON_LC_PERSON"},
    {name:"COMMON_LC_B2B"}
]

export const commonAgeGroup = [
    {name:"COMMON_AG_15TO20"},
    {name:"COMMON_AG_21TO30"},
    {name:"COMMON_AG_31TO50"},
    {name : "COMMON_AG_ABOVE50"}
]

export const commonMaritalStatus = [
    {name:"COMMON_MS_MARRIED"},
    {name:"COMMON_MS_UNMARRIED"},
    {name:"COMMON_MS_DIVORCED"},
    {name: "COMMON_MS_WIDOWED"}
]

export const commonIncomeGroup = [
    {name:"COMMON_IG_UPTO5_LAKH"},
    {name:"COMMON_IG_5TO10_LAKH"},
    {name:"COMMON_IG_10TO20_LAKH"},
    {name:"COMMON_IG_ABOVE20_LAKH"}
]

export const customizationDropdown = [
    {
        label : "CUSTOMIZATION_DD_LEAD",
        value : "LEAD"
    },
    {
        label : "CUSTOMIZATION_DD_CUSTOMER",
        value : "CUSTOMER"
    },
    {
        label : "CUSTOMIZATION_DD_TASK",
        value : "TASK"
    },
    {
        label : "CUSTOMIZATION_DD_PRODUCT",
        value : "PRODUCT"
    },
    {
        label : "CUSTOMIZATION_DD_VENDOR",
        value : "VENDOR"
    },
]
export const dateTimeISTFormatter = (value)=>{
   return new Date(value).toLocaleString(undefined, {
    timeZone: 'Asia/Kolkata'
    })
}

export const formatDateOnly = (value) => {
    if (!value) return "";
    try {
        const formatted = dateTimeISTFormatter(value);
        return formatted.split(',')[0];
    } catch (e) {
        return "";
    }
};

export const formatSourceProductDates = (sourceProducts) => {
    if (!Array.isArray(sourceProducts)) return [];

    return sourceProducts
        .map(item => ({
            name: item.name,
            date: formatDateOnly(item.lastBoughtDate),
        }))
        .filter(item => item.date);
};


export const ACTIVITY_TYPE_LABELS = {
  EMAIL_SENT:      'Email Sent',
  EMAIL_RECEIVED:  'Email Received',
  WHATSAPP_SENT:   'WhatsApp Sent',
  CALL_OUTGOING:   'Call Outgoing',
  CALL_INCOMING:   'Call Incoming',
  NOTE:            'Note',
};


export const buildActivityHeader = (activityType, recipients, createdAtUtc, callStatus, callDuration) => {
  const label = ACTIVITY_TYPE_LABELS[activityType] || activityType || 'Activity';
  const timeStr = createdAtUtc ? dateTimeISTFormatter(createdAtUtc) : '';

  const isInbound = activityType === 'CALL_INCOMING' || activityType === 'EMAIL_RECEIVED';
  const directionLabel = isInbound ? 'From' : 'To';

  let callDurationStr = null;
  if (callDuration != null) {
    const mins = Math.floor(callDuration / 60);
    const secs = callDuration % 60;
    callDurationStr = mins > 0 ? `${mins}m ${secs}s` : `${secs}s`;
  }

  return {
    label,
    directionLabel,
    recipientStr: recipients || '',
    timeStr,
    callStatus: callStatus || null,
    callDurationStr,
  };
};


export const templateParams = [
    {
        label : "TEMP_PARAM_RECEIVER_NAME",
        value : "{{name}}"
    },
    {
        label : "TEMP_PARAM_PRODUCTS",
        value : "{{products}}"

    },
    {
        label : "TEMP_PARAM_CLIENT_NAME",
        value : "{{client_name}}"

    },
    {
        label : "TEMP_PARAM_CLIENT_EMAIL",
        value : "{{client_email}}"

    },
    {
        label : "TEMP_PARAM_CLIENT_MOB_NO", 
        value : "{{client_phone}}"

    },
    {
        label : "TEMP_PARAM_TASK_ID",
        value : "{{task_id}}"

    }
]

export const LeadSystemLookUp = {
    LEAD_STATUS_PROSPECT : "LEAD_STATUS_PROSPECT",
    LEAD_STATUS_OPEN: "LEAD_STATUS_OPEN",
    LEAD_STATUS_DEAL_CLOSED: "LEAD_STATUS_DEAL_CLOSED",
    LEAD_STATUS_CANCELLED: "LEAD_STATUS_CANCELLED",
    LEAD_STATUS_OVERRIDE: "LEAD_STATUS_OVERRIDE"
}

export const TaskSystemLookUp = {
    TASK_STATUS_OPEN: "TASK_STATUS_OPEN",
    TASK_STATUS_CLOSED: "TASK_STATUS_CLOSED",
    TASK_STATUS_CANCELLED: "TASK_STATUS_CANCELLED",
    TASK_STATUS_OVERRIDE: "TASK_STATUS_OVERRIDE",
    TASK_STATUS_WIP: "TASK_STATUS_WIP"
}
export const promotionalMailType = [
    {
        label : "PROMOTION_MAIL_TYPE_PROMOTION", 
        value : "External"
    },
    {
        label : "PROMOTION_MAIL_TYPE_LEAD", 
        value : "Lead"
    },
    {
        label : "PROMOTION_MAIL_TYPE_CUSTOMER", 
        value : "Customer"
    }
]
export const MAX_TOTAL_SIZE = 25 * 1024 * 1024

export const userStatus = {
    USER_STATUS_ACTIVE : "USER_STATUS_ACTIVE",
    USER_STATUS_INACTIVE : "USER_STATUS_INACTIVE"
}
export const checkIsActionDisabled = (statusData, rowStatus, closedStatus, cancelledStatus, hasPermission) => {
    const matchedStatus = statusData?.find(item => item?.name === rowStatus);
    const isClosedOrCancelled =
        matchedStatus?.systemLookupCode?.name === closedStatus ||
        matchedStatus?.systemLookupCode?.name === cancelledStatus;
    return !hasPermission || isClosedOrCancelled;
};

export const templateChannel = [
    {
        label : "TEMPLATE_CHANNEL_WHATSAPP",
    },
    {
        label : "TEMPLATE_CHANNEL_EMAIL",
    }
]

export const ADDITIONAL_ATTRIBUTE_FIELDS = [
  "attribute1",
  "attribute2",
  "attribute3",
  "attribute4",
  "attribute5",
];
export const CUSTOMIZABLE_FIELDS_LEAD = [
  "title",
  "type",
  "ageGroup",
  "maritalStatus",
  "income",
];
export const CUSTOMIZABLE_FIELDS_CUSTOMER = [
  "title",
  "type",
  "ageGroup",
  "maritalStatus",
  "incomeGroup",
];

export const ADDITIONAL_ATTRIBUTE_FIELDS_TYPES =  [
            { label: "Text", value: "Text" },
            { label: "Pick List - Multi Select", value: "Pick List - Multi Select" },
            { label: "Pick List - Single Select", value: "Pick List - Single Select" },
          ]
export const ATTRIBUTE_TYPE_TEXT = "Text";
export const ATTRIBUTE_TYPE_SINGLE_SELECT= "Pick List - Single Select";
export const ATTRIBUTE_TYPE_MULTI_SELECT= "Pick List - Multi Select";

export const PICK_LIST_TYPE_ARRAY = [
    ATTRIBUTE_TYPE_SINGLE_SELECT,
    ATTRIBUTE_TYPE_MULTI_SELECT
]

export const STATIC_ENTITY_CONFIG = {
    LEAD: {
        id: {
        name: "id",
        label: "LEAD_EDIT_LEAD_ID",
        visibility: true,
        mandatory: true,
        editable: false,
        },
        customerId: {
        name: "customerId",
        label: "LEAD_EDIT_CUSTOMER_ID",
        visibility: true,
        mandatory: false,
        editable: false,
        },
        status: {
        name: "status",
        label: "LEAD_EDIT_STATUS",
        visibility: true,
        mandatory: true,
        editable: false,
        },
        selectedOwner: {
        name: "selectedOwner",
        label: "LEAD_EDIT_OWNER",
        visibility: true,
        mandatory: true,
        editable: false,
        },
        selectedSource: {
        name: "selectedSource",
        label: "LEAD_EDIT_SOURCE",
        visibility: true,
        mandatory: false,
        editable: true,
        },
        desirability: {
        name: "desirability",
        label: "LEAD_EDIT_DESIRABILITY",
        visibility: true,
        mandatory: false,
        editable: false,
        },
        totalValue: {
        name: "totalValue",
        label: "LEAD_EDIT_TOTAL_VALUE",
        visibility: true,
        mandatory: false,
        editable: false,
        },
        phone : {
        name: "phone",
        label: "COMMON_PHONE_NUMBER",
        visibility: true,
        mandatory: false,
        editable: false,
        },
        email: {
        name: "email",
        label: "COMMON_EMAIL_ID",
        visibility: true,
        mandatory: true,
        editable: false,
        },
        title: {
        name: "title",
        label: "COMMON_TITLE",
        visibility: true,
        mandatory: false,
        editable: true,
        type : ATTRIBUTE_TYPE_SINGLE_SELECT,
        options : commonTitles,
        },
        firstName: {
        name: "firstName",
        label: "LEAD_EDIT_FIRSTNAME",
        visibility: true,
        mandatory: false,
        editable: true,
        },
        lastName: {
        name: "lastName",
        label: "LEAD_EDIT_LASTNAME",
        visibility: true,
        mandatory: false,
        editable: true,
        },
        externalNumber: {
        name: "externalNumber",
        label: "LEAD_EDIT_EXTERNAL_NUMBER",
        visibility: true,
        mandatory: false,
        editable: true,
        },
        type: {
        name: "type",
        label: "COMMON_LC_TYPE",
        visibility: true,
        mandatory: false,
        editable: true,
        type : ATTRIBUTE_TYPE_SINGLE_SELECT,
        options : commonLCType,
        },
        ageGroup: {
        name: "ageGroup",
        label: "COMMON_AGE_GROUP",
        visibility: true,
        mandatory: false,
        editable: true,
        type : ATTRIBUTE_TYPE_SINGLE_SELECT,
        options : commonAgeGroup,
        },
        maritalStatus: {
        name: "maritalStatus",
        label: "COMMON_MARITAL_STATUS",
        visibility: true,
        mandatory: false,
        editable: true,
        type : ATTRIBUTE_TYPE_SINGLE_SELECT,
        options : commonMaritalStatus,
        },
        occupation: {
        name: "occupation",
        label: "LEAD_EDIT_OCCUPATION",
        visibility: true,
        mandatory: false,
        editable: true,
        },
        income: {
        name: "income",
        label: "COMMON_INCOME_GROUP",
        visibility: true,
        mandatory: false,
        editable: true,
        type : ATTRIBUTE_TYPE_SINGLE_SELECT,
        options : commonIncomeGroup,
        },
        attribute1: {
            name: "attribute1",
            label: "LEAD_ADD_ATTRIBUTE_1",
            visibility: true,
            mandatory: false,
            editable: true,
            type : ATTRIBUTE_TYPE_TEXT,
        },
        attribute2: {
            name: "attribute2",
            label: "LEAD_ADD_ATTRIBUTE_2",
            visibility: true,
            mandatory: false,
            editable: true,
            type : ATTRIBUTE_TYPE_TEXT,
        },
        attribute3: {
            name: "attribute3",
            label: "LEAD_ADD_ATTRIBUTE_3",
            visibility: true,
            mandatory: false,
            editable: true,
            type : ATTRIBUTE_TYPE_TEXT,
        },
        attribute4: {
            name: "attribute4",
            label: "LEAD_ADD_ATTRIBUTE_4",
            visibility: true,
            mandatory: false,
            editable: true,
            type : ATTRIBUTE_TYPE_TEXT,
        },
        attribute5: {
            name: "attribute5",
            label: "LEAD_ADD_ATTRIBUTE_5",
            visibility: true,
            mandatory: false,
            editable: true,
            type : ATTRIBUTE_TYPE_TEXT,
        },
    },
    CUSTOMER: {
        customerId: {
            name: "customerId",
            label: "CUST_EDIT_CUSTOMER_ID",
            visibility: true,
            mandatory: true,
            editable: false,
        },
        status: {
            name: "status",
            label: "CUST_EDIT_STATUS",
            visibility: true,
            mandatory: true,
            editable: false,
        },
        selectedSource: {
            name: "selectedSource",
            label: "CUST_SOURCE",
            visibility: true,
            mandatory: false,
            editable: true,
        },
        totalValue: {
            name: "totalValue",
            label: "CUSTOMER_TOTAL_VALUE",
            visibility: true,
            mandatory: false,
            editable: false,
        },
        phone: {
            name: "phone",
            label: "COMMON_PHONE_NUMBER",
            visibility: true,
            mandatory: false,
            editable: false,
        },
        email: {
            name: "email",
            label: "COMMON_EMAIL_ID",
            visibility: true,
            mandatory: true,
            editable: false,
        },
        title: {
            name: "title",
            label: "COMMON_TITLE",
            visibility: true,
            mandatory: false,
            editable: true,
            type : ATTRIBUTE_TYPE_SINGLE_SELECT,
            options : commonTitles,
        },
        firstName: {
            name: "firstName",
            label: "CUST_EDIT_FIRSTNAME",
            visibility: true,
            mandatory: false,
            editable: true,
        },
        lastName: {
            name: "lastName",
            label: "CUST_EDIT_LASTNAME",
            visibility: true,
            mandatory: false,
            editable: true,
        },
        externalNumber: {
            name: "externalNumber",
            label: "CUST_EDIT_EXTERNAL_NUMBER",
            visibility: true,
            mandatory: false,
            editable: true,
        },
        type: {
            name: "type",
            label: "COMMON_LC_TYPE",
            visibility: true,
            mandatory: false,
            editable: true,
            type : ATTRIBUTE_TYPE_SINGLE_SELECT,
            options : commonLCType,
        },
        ageGroup: {
            name: "ageGroup",
            label: "COMMON_AGE_GROUP",
            visibility: true,
            mandatory: false,
            editable: true,
            type : ATTRIBUTE_TYPE_SINGLE_SELECT,
            options : commonAgeGroup,
        },
        maritalStatus: {
            name: "maritalStatus",
            label: "COMMON_MARITAL_STATUS",
            visibility: true,
            mandatory: false,
            editable: true,
            type : ATTRIBUTE_TYPE_SINGLE_SELECT,
            options : commonMaritalStatus,
        },
        occupation: {
            name: "occupation",
            label: "CUST_EDIT_OCCUPATION",
            visibility: true,
            mandatory: false,
            editable: true,
        },
        incomeGroup: {
            name: "incomeGroup",
            label: "COMMON_INCOME_GROUP",
            visibility: true,
            mandatory: false,
            editable: true,
            type : ATTRIBUTE_TYPE_SINGLE_SELECT,
            options : commonIncomeGroup,
        },
        attribute1: {
            name: "attribute1",
            label: "CUST_EDIT_ATTRIBUTE1",
            visibility: true,
            mandatory: false,
            editable: true,
            type : ATTRIBUTE_TYPE_TEXT,
        },
        attribute2: {
            name: "attribute2",
            label: "CUST_EDIT_ATTRIBUTE2",
            visibility: true,
            mandatory: false,
            editable: true,
            type : ATTRIBUTE_TYPE_TEXT,
        },
        attribute3: {
            name: "attribute3",
            label: "CUST_EDIT_ATTRIBUTE3",
            visibility: true,
            mandatory: false,
            editable: true,
            type : ATTRIBUTE_TYPE_TEXT,
        },
        attribute4: {
            name: "attribute4",
            label: "CUST_EDIT_ATTRIBUTE4",
            visibility: true,
            mandatory: false,
            editable: true,
            type : ATTRIBUTE_TYPE_TEXT,
        },
        attribute5: {
            name: "attribute5",
            label: "CUST_EDIT_ATTRIBUTE5",
            visibility: true,
            mandatory: false,
            editable: true,
            type : ATTRIBUTE_TYPE_TEXT,
        },
    },
    TASK : {
        id: {
            name: "id",
            label: "TASK_EDIT_TASK_ID",
            visibility: true,
            mandatory: true,
            editable: false,
        },
        selectedOwner: {
            name: "selectedOwner",
            label: "TASK_SEARCH_OWNER",
            visibility: true,
            mandatory: true,
            editable: false,
        },
        selectedCustomer: {
            name: "selectedCustomer",
            label: "TASK_EDIT_CUSTOMER",
            visibility: true,
            mandatory: false,
            editable: false,
        },
        status: {
            name: "status",
            label: "TASK_EDIT_STATUS",
            visibility: true,
            mandatory: false,
            editable: false,
        },
        primaryType: {
            name: "primaryType",
            label: "TASK_EDIT_PT",
            visibility: true,
            mandatory: true,
            editable: false,
        },
        secondaryType: {
            name: "secondaryType",
            label: "TASK_EDIT_ST",
            visibility: true,
            mandatory: true,
            editable: false,
        },
        source: {
            name: "source",
            label: "TASK_EDIT_SOURCE",
            visibility: true,
            mandatory: false,
            editable: true,
        },
        priority: {
            name: "priority",
            label: "TASK_EDIT_PRIORITY",
            visibility: true,
            mandatory: false,
            editable: false,
        },
        description : {
            name : "description",
            label : "TASK_EDIT_DESCRIPTION",
            visibility : true,
            mandatory :true,
            editable : false
        },
        attribute1: {
            name: "attribute1",
            label: "TASK_EDIT_ATTRIBUTE1",
            visibility: true,
            mandatory: false,
            editable: true,
            type : ATTRIBUTE_TYPE_TEXT,
        },
        attribute2: {
            name: "attribute2",
            label: "TASK_EDIT_ATTRIBUTE2",
            visibility: true,
            mandatory: false,
            editable: true,
            type : ATTRIBUTE_TYPE_TEXT,
        },
        attribute3: {
            name: "attribute3",
            label: "TASK_EDIT_ATTRIBUTE3",
            visibility: true,
            mandatory: false,
            editable: true,
            type : ATTRIBUTE_TYPE_TEXT,
        },
        attribute4: {
            name: "attribute4",
            label: "TASK_EDIT_ATTRIBUTE4",
            visibility: true,
            mandatory: false,
            editable: true,
            type : ATTRIBUTE_TYPE_TEXT,
        },
        attribute5: {
            name: "attribute5",
            label: "TASK_EDIT_ATTRIBUTE5",
            visibility: true,
            mandatory: false,
            editable: true,
            type : ATTRIBUTE_TYPE_TEXT,
        },
    },
    PRODUCT: {
        id: {
            name: "id",
            label: "PROD_EDIT_PRODUCT_ID",
            visibility: true,
            mandatory: true,
            editable: false,
        },

        name: {
            name: "name",
            label: "PROD_EDIT_PRODUCT_NAME",
            visibility: true,
            mandatory: true,
            editable: false,
        },

        status: {
            name: "status",
            label: "PRODUCT_STATUS",
            visibility: true,
            mandatory: true,
            editable: false,
        },

        description: {
            name: "description",
            label: "PROD_EDIT_DESCRIPTION",
            visibility: true,
            mandatory: false,
            editable: false,
        },

        type: {
            name: "type",
            label: "PRODUCT_TYPE",
            visibility: true,
            mandatory: true,
            editable: false,
        },

        unitOfMeasurement: {
            name: "unitOfMeasurement",
            label: "PRODUCT_UOM",
            visibility: true,
            mandatory: true,
            editable: false,
        },

        sellingPrice: {
            name: "sellingPrice",
            label: "PROD_EDIT_SP",
            visibility: true,
            mandatory: true,
            editable: false,
        },
        
        cgstPercentage: {
            name: "cgstPercentage",
            label: "PROD_EDIT_CGST_PERCENT",
            visibility: true,
            mandatory: false,
            editable: false,
        },
        
        sgstPercentage: {
            name: "sgstPercentage",
            label: "PROD_EDIT_SGST_PERCENT",
            visibility: true,
            mandatory: false,
            editable: false,
        },

        surchargePercentage: {
            name: "surchargePercentage",
            label: "PROD_EDIT_SURCHARGE_PERCENT",
            visibility: true,
            mandatory: false,
            editable: true,
        },

        selectedVendor: {
            name: "selectedVendor",
            label: "PROD_EDIT_VENDOR",
            visibility: true,
            mandatory: false,
            editable: true,
        },

        mrp: {
            name: "mrp",
            label: "PROD_EDIT_MRP",
            visibility: true,
            mandatory: false,
            editable: true,
        },

        discount1Percentage: {
            name: "discount1Percentage",
            label: "PROD_EDIT_DISCOUNT1_PERCENT",
            visibility: true,
            mandatory: false,
            editable: true,
        },

        discount2Percentage: {
            name: "discount2Percentage",
            label: "PROD_EDIT_DISCOUNT2_PERCENT",
            visibility: true,
            mandatory: false,
            editable: true,
        },

        discount3Percentage: {
            name: "discount3Percentage",
            label: "PROD_EDIT_DISCOUNT3_PERCENT",
            visibility: true,
            mandatory: false,
            editable: true,
        },

        attribute1: {
            name: "attribute1",
            label: "PROD_EDIT_ATTRIBUTE1",
            visibility: true,
            mandatory: false,
            editable: true,
            type : ATTRIBUTE_TYPE_TEXT,
        },

        attribute2: {
            name: "attribute2",
            label: "PROD_EDIT_ATTRIBUTE2",
            visibility: true,
            mandatory: false,
            editable: true,
            type : ATTRIBUTE_TYPE_TEXT,
        },

        attribute3: {
            name: "attribute3",
            label: "PROD_EDIT_ATTRIBUTE3",
            visibility: true,
            mandatory: false,
            editable: true,
            type : ATTRIBUTE_TYPE_TEXT,
        },

        attribute4: {
            name: "attribute4",
            label: "PROD_EDIT_ATTRIBUTE4",
            visibility: true,
            mandatory: false,
            editable: true,
            type : ATTRIBUTE_TYPE_TEXT,
        },

        attribute5: {
            name: "attribute5",
            label: "PROD_EDIT_ATTRIBUTE5",
            visibility: true,
            mandatory: false,
            editable: true,
            type : ATTRIBUTE_TYPE_TEXT,
        },
    },
    VENDOR : {

        name: {
            name: "name",
            label: "VEND_EDIT_NAME",
            visibility: true,
            mandatory: true,
            editable: false,
        },

        status: {
            name: "status",
            label: "VEND_EDIT_STATUS",
            visibility: true,
            mandatory: true,
            editable: false,
        },
        email: {
            name: "email",
            label: "COMMON_EMAIL_ID",
            visibility: true,
            mandatory: true,
            editable: false,      
        },
        phone: {
            name: "phone",
            label: "COMMON_PHONE_NUMBER",
            visibility: true,
            mandatory: false,
            editable: false,
        },
        attribute1: {
            name: "attribute1",
            label: "VEND_EDIT_ATTRIBUTE1",
            visibility: true,
            mandatory: false,
            editable: true,
            type : ATTRIBUTE_TYPE_TEXT,
        },

        attribute2: {
            name: "attribute2",
            label: "VEND_EDIT_ATTRIBUTE2",
            visibility: true,
            mandatory: false,
            editable: true,
            type : ATTRIBUTE_TYPE_TEXT,
        },

        attribute3: {
            name: "attribute3",
            label: "VEND_EDIT_ATTRIBUTE3",
            visibility: true,
            mandatory: false,
            editable: true,
            type : ATTRIBUTE_TYPE_TEXT,
        },

        attribute4: {
            name: "attribute4",
            label: "VEND_EDIT_ATTRIBUTE4",
            visibility: true,
            mandatory: false,
            editable: true,
            type : ATTRIBUTE_TYPE_TEXT,
        },

        attribute5: {
            name: "attribute5",
            label: "VEND_EDIT_ATTRIBUTE5",
            visibility: true,
            mandatory: false,
            editable: true,
            type : ATTRIBUTE_TYPE_TEXT,
        },
    }
};

export const phoneCountryCodes = {
    altPhoneCountryCode : "+91",
    pocPhoneCountryCode : "+91",
    phoneCountryCode : "+91"
}

export const getLeadScoreColor = (score) => {
  if ((score == null || score >=0) && score < 40  ) return '#FFCC9C';
  if (score >= 40 && score < 75) return '#79B1CC';
  if (score >= 75) return '#B950CB';
};

export const ARRAY_SERIALIZER = (params) =>
  qs.stringify(params, { arrayFormat: "repeat" });

export const searchEntity = {
    customer : "customer",
    lead : "lead",
    task : "task",
    product : "product",
    vendor : "vendor",
    salesOrder : "salesOrder",
    invoice : "invoice",
    template : "template",
    workflow : "workflow",
    user : "user"
}
export const DEFAULT_PAGE_SIZE = 50;
export const ROWS_PER_PAGE_OPTIONS = [25, 50, 100];

export const TEMPLATE_TABS = Object.freeze({
    TAB_TEMPLATES: "TAB_TEMPLATES",
    TAB_PROMOTIONS: "TAB_PROMOTIONS",
    TAB_USER_EMAIL_SETTING: "TAB_USER_EMAIL_SETTING",
    TAB_EMAIL_TO_TASK: "TAB_EMAIL_TO_TASK",
    TAB_WEB_TO_LEAD: "TAB_WEB_TO_LEAD",
    TAB_WHATSAPP_SETTINGS: "TAB_WHATSAPP_SETTINGS",
    TAB_TELECALLING_SETTINGS: "TAB_TELECALLING_SETTINGS",
});

export const RECOMMENED_PRODUCTS_FOLLOWUP_NOTE= "Created a new lead for pitching the recommended products.";

export const DB_ACTIONABLES_TABS = {
    DB_ACTIONABLES_TAB_TASKS : "DB_ACTIONABLES_TAB_TASKS",
    DB_ACTIONABLES_TAB_LEADS : "DB_ACTIONABLES_TAB_LEADS"
}

export const CHILD_DATAGRIDTABLE_HEIGHT = {
    md : 'calc(100vh - 250px)',
    lg : 'calc(100vh - 370px)',
}
export const ROWS_TO_VIEW_IN_CHILD_TABLE = 4;
    export const ruleEngineLookupList = [
        {
            label : "LEAD_STATUS",
            value : "LEAD_STATUS"
        }
    ]

    export const RE_STATUS = {
        RE_STATUS_ACTIVE : "RE_STATUS_ACTIVE",
        RE_STATUS_INACTIVE : "RE_STATUS_INACTIVE"
    }

    export const DEFAULT_HEADER_HEIGHT_PX = 60;
    export const DEFAULT_FOOTER_HEIGHT_PX = 52;
    export const DEFAULT_TOOLBAR_HEIGHT_PX = 68;
    export const i18HashMapKey='biztantu_i18n_hashmap';

export const MCP_ENDPOINT = "https://api.biztantu.com/mcp";

export const MCP_CLIENT_OPTIONS = [
  { label: "Cursor / VS Code", value: "cursor" },
  { label: "Google Antigravity", value: "antigravity" },
  { label: "Claude Desktop", value: "claude" },
  { label: "ChatGPT / Codex (TOML)", value: "chatgpt" },
  { label: "Windsurf (Codeium)", value: "windsurf" },
];

export const getSnippetByClient = (clientType, tokenValue, endpoint = MCP_ENDPOINT) => {
  const token = tokenValue || "<your-personal-access-token>";

  switch (clientType) {
    case "antigravity":
      return JSON.stringify(
        {
          mcpServers: {
            "biztantu-leads": {
              serverUrl: `${endpoint}?token=${token}`,
            },
          },
        },
        null,
        2
      );

    case "claude":
      return JSON.stringify(
        {
          mcpServers: {
            "biztantu-leads": {
              command: "npx",
              args: ["-y", "mcp-remote", `${endpoint}?token=${token}`],
            },
          },
        },
        null,
        2
      );

    case "windsurf":
      return JSON.stringify(
        {
          mcpServers: {
            "biztantu-leads": {
              serverUrl: `${endpoint}?token=${token}`,
            },
          },
        },
        null,
        2
      );

    case "chatgpt":
      return `[mcp_servers.biztantu]\nurl = "${endpoint}"\n\n[mcp_servers.biztantu.headers]\nAuthorization = "Bearer ${token}"`;

    case "cursor":
    default:
      return JSON.stringify(
        {
          mcpServers: {
            "biztantu-leads": {
              url: endpoint,
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          },
        },
        null,
        2
      );
  }
};
